"use client";

import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const Presentation = () => {
  return (
    <Container>
      <div className={S.wrapper}>
        <iframe
          width="1400"
          height="787"
          src="https://rutube.ru/play/embed/624dc1e8ecb3e0fbe909cee417bbc382/?p=XpxFmZK2lLojJKHPJpx4CA&skinColor=000000"
          allow="clipboard-write; autoplay"
          title="ЭПК"
          allowFullScreen
        ></iframe>
      </div>
    </Container>
  );
};

export default Presentation;
